<div class="inner-content" padding>
  <form [formGroup]="qcForm">
    <ion-grid>
      <ion-row>
        <ion-col size="12" text-center class="order-title flex-content-center">
          <ion-icon name="document" color="dark"></ion-icon>&nbsp;
          <ion-text font-bold="" color="dark">
            {{ orderDetails?.formattedId }}</ion-text
          >
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="12"
          no-padding-top
          text-center=""
          class="item-name flex-content-center"
        >
          <ion-img [src]="orderDetails?.orderItems[0].item?.icon"></ion-img>
          <ion-text font-bold="" color="dark">{{
            orderDetails?.orderItems[0].item?.name
          }}</ion-text>
        </ion-col>
        <ion-col
          size="12"
          text-center
          class="enter-qty"
          margin-top=""
          padding-top
        >
          <ion-text font-bold="" color="dark">ENTER PERCENT DEDUCTION</ion-text>
          <!--<ion-text font-bold="" color="dark">&</ion-text>
                    <br/>
                    <ion-text font-bold="" color="dark">REJECTED WEIGHT</ion-text>-->
        </ion-col>
        <ion-col size="12" class="enter-qty-text" text-center="">
          <ion-text color="medium" text-regular="">
            Enter the percentage you want to deduct
          </ion-text>
        </ion-col>
        <ion-col size="12" text-center margin-bottom="" class="qty-input">
          <ion-item
            lines="none"
            [ngClass]="{
              'item-error':
                (orderDetails?.orderItems[0].deductedPercentage <= 0 &&
                  orderDetails?.orderItems[0].deductedPercentage != null) ||
                isFloat(orderDetails?.orderItems[0].deductedPercentage)
            }"
          >
            <ion-input
              #qtyInput
              no-padding=""
              no-margin
              font-bold
              [(ngModel)]="orderDetails?.orderItems[0].deductedPercentage"
              maxlength="10"
              clear-on-edit
              name="deductedPercentage"
              formControlName="deductedPercentage"
              type="number"
              required=""
            ></ion-input>
            <ion-label no-margin slot="end" text-medium color="medium">
              %
            </ion-label>
            <div no-margin slot="end" class="plus-minus-btn">
              <ion-icon
                name="arrow-dropup"
                color="medium"
                (click)="
                  orderDetails?.orderItems[0].deductedPercentage =
                    orderDetails?.orderItems[0].deductedPercentage + 1
                "
              ></ion-icon>
              <ion-icon
                name="arrow-dropdown"
                color="medium"
                (click)="
                  orderDetails?.orderItems[0].deductedPercentage > 0
                    ? (orderDetails?.orderItems[0].deductedPercentage =
                        orderDetails?.orderItems[0].deductedPercentage - 1)
                    : (orderDetails?.orderItems[0].deductedPercentage = 0)
                "
              >
              </ion-icon>
            </div>
          </ion-item>
        </ion-col>

        <ion-col size="12" text-center class="enter-qty" margin-top="">
          <ion-text font-bold="" color="dark">ENTER REJECTED QUANTITY</ion-text>
        </ion-col>
        <ion-col size="12" class="enter-qty-text" text-center="">
          <ion-text color="medium" text-regular="">
            Enter the quantity you want to reject and deduct
          </ion-text>
        </ion-col>
        <ion-col size="12" text-center margin-bottom="" class="qty-input">
          <ion-item
            lines="none"
            [ngClass]="{
              'item-error':
                (orderDetails?.orderItems[0].rejectedQty <= 0 &&
                  orderDetails?.orderItems[0].rejectedQty != null) ||
                isFloat(orderDetails?.orderItems[0].rejectedQty)
            }"
          >
            <ion-input
              #qtyInput
              no-padding=""
              no-margin
              font-bold
              [(ngModel)]="orderDetails?.orderItems[0].rejectedQty"
              maxlength="10"
              clear-on-edit
              name="rejectedQty"
              formControlName="rejectedQty"
              type="number"
              required=""
            ></ion-input>
            <ion-label no-margin slot="end" text-medium color="medium">{{
              orderDetails?.orderItems[0]?.item?.unitType
            }}</ion-label>
            <div no-margin slot="end" class="plus-minus-btn">
              <ion-icon
                name="arrow-dropup"
                color="medium"
                (click)="
                  orderDetails?.orderItems[0].rejectedQty =
                    orderDetails?.orderItems[0].rejectedQty + 1
                "
              ></ion-icon>
              <ion-icon
                name="arrow-dropdown"
                color="medium"
                (click)="
                  orderDetails?.orderItems[0].rejectedQty > 0
                    ? (orderDetails?.orderItems[0].rejectedQty =
                        orderDetails?.orderItems[0].rejectedQty - 1)
                    : (orderDetails?.orderItems[0].rejectedQty = 0)
                "
              >
              </ion-icon>
            </div>
          </ion-item>
        </ion-col>

        <ion-col size="12" text-center="" margin-top class="upload-title">
          <ion-text font-bold="" color="dark">Upload Lab Reports</ion-text>
        </ion-col>
        <ion-col size="12" text-center="" class="upload-sub-title">
          <ion-text color="medium"
            >This reports are required as proof of deductions</ion-text
          >
        </ion-col>
        <ion-col size="12" class="img-list">
          <rcyl-img-list
            [docList]="orderLabReportDocs"
            (onCapture)="labReportImgCapture()"
            [docType]="orderDocumentTypes.LAB_REPORT"
            [downloadDocumentCallback]="deleteDocumentCallback"
            [deleteDocumentCallback]="deleteDocumentCallback"
            [showDelete]="true"
            [showCapture]="true"
          ></rcyl-img-list>
        </ion-col>
        <ion-col size="12" text-center="" class="upload-note">
          <ion-text color="medium">
            <i>
              <span font-bold="">Note •</span> You can mark the order as QC'ed
              only after uploading the lab reports
            </i>
          </ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</div>
<ion-footer no-border>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-button
          [disabled]="qcForm.invalid || orderLabReportDocs?.length <= 0"
          color="primary"
          size="large"
          expand="block"
          (click)="doneClicked()"
        >
          Done
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
